import ReturnMessage from '../ReturnMessage'
import SelectInput from '../SelectInput'
import Button from '../Button'
import LoadingOverlay from '../LoadingOverlay'
import usePost from '../../hooks/usePost'
import {useContext, useEffect, useState} from 'react'
import {useLocation} from 'react-router'
import format from "date-fns/format"
import poweredByContext from '../../store/PoweredByContext'
import {Link, useNavigate} from 'react-router-dom'
import ModalFormWrapper from '../ModalFormWrapper'
import tick from '../../assets/icons/tick-big.svg'
import { kycHeatList } from '../../data/portalFormListData'
import chevronDown from '../../assets/icons/chevron-down-big-white.svg'
import Checkbox from '../Checkbox'


const PortalMoveToRfqModal = ({closeModal, closedBy, dealId}) => {

    // State
    const [validateForm, setValidateForm] = useState(false)
    const [reason, setReason] = useState('')
    const [hasFlownPrivate, setHasFlownPrivate] = useState(false)
    
    const [validateReset, setValidateReset] = useState(false)
    const [resetSuccess, setResetSuccess] = useState(false)

    // Hooks
    const {sending: loading, returnMessage, postData} = usePost()
    const {sending, returnData: resetData, returnMessage: resetClosedMessage, postData: postClosed} = usePost()
    //const authCtx = useContext(authContext)
    const poweredByCtx = useContext(poweredByContext)
    const navigate = useNavigate()

    
    // Use effect
    useEffect(() => {
        if(resetData){
            closeModal()
        }

    }, [closeModal, reason, navigate, postData, resetSuccess, validateReset, dealId])

    // Submit
    const submitHandler = (e) => {

        e.preventDefault()
        setValidateForm(true)

        // Form complete
        if (reason && reason.length > 1) {

            // Set data
            let formData = {
                kycHeat: reason,
                hasFlownPrivate: hasFlownPrivate,
                dealId: dealId
            }

            // Post
            postClosed(formData, '/api/portal/setDealRFQ', 1000)
        }
    }

    return (
        <ModalFormWrapper
            title='Move to RFQ'
        >
            <ReturnMessage returnMessage={resetClosedMessage} />

            {(loading || sending) ?
                <LoadingOverlay />
                :
                returnMessage.error ?
                    <div className='login-form'>

                        <div className='login-form__body'>
                            <div className='login-form__success'>
                                <div className='login-form__body__title'>
                                    Could not progress deal
                                </div>
                                <br /><br/>
                                <div className='login-form__body__submit-container'>
                                    <Link to='/portal'>
                                        <Button onClick={closeModal} disabled={sending} classNames={['button--full']}>Return</Button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    resetSuccess ?
                        <div className='login-form'>
                            <div className='login-form__success'>
                                <img className='login-form__success__tick' src={tick} alt='' />
                                <div className='login-form__success__message'>The deal has been moved</div>
                                <Button onClick={closeModal}>Return</Button>
                            </div>
                        </div>
                        :
                        <div className='login-form'>

                            <div className='login-form__body'>

                                <div className='login-form__body__title'>
                                    You are setting this deal to "Ready for quote"
                                </div>
                                <div className='login-form__body__intro'>
                                    Please check the details below
                                </div>

                                <form onSubmit={submitHandler}>
                                <SelectInput
                                        value={(value) => setReason(value)}
                                        options={kycHeatList}
                                        label='KYC Heat*'
                                        required
                                        chevron={chevronDown}
                                        validateForm={validateForm}
                                        classNames={['select-input--full select-input--form']}
                                    />
                                    
                                    <Checkbox 
                                        defaultValue={hasFlownPrivate} 
                                        classNames={['checkbox--aircraft-compare']} 
                                        tickDark 
                                        value={(value) => setHasFlownPrivate(value)} 
                                    >Has flown private before?</Checkbox>

                                    <div className='login-form__body__submit-container'>
                                        <Button disabled={sending} classNames={['button--full']}>Save</Button>
                                    </div>

                                </form>

                                {sending && <LoadingOverlay />}

                            </div>
                        </div>
            }
        </ModalFormWrapper>
    )
}

export default PortalMoveToRfqModal